<template>
    <div class="icon-container" :style="[styles, { width: `${width}px`, height: `${height}px` }]">
        <div v-html="svgContent" class="icon-svg" />
    </div>
</template>

<script>
export default {
    name: 'Icon',
    props: {
        name: {
            type: String,
            required: true,
            validator: (value) => !!value.trim(),
        },
        width: {
            type: [String, Number],
            default: '18', // Default width in pixels
        },
        height: {
            type: [String, Number],
            default: '18', // Default height in pixels
        },
        styles: {
            type: Object,
            default: () => ({}), // Allow custom styles via object
        },
        isOutlined: { type: Boolean, default: false },
    },
    data() {
        return {
            svgContent: null, // Holds the raw SVG markup
        };
    },
    computed: {
        iconUrl() {
            // Construct the dynamic URL based on the provided name
            return `${window.env.ICONS_URL}/${this.name}${this.isOutlined ? 'Outlined' : ''}.svg`;
        },
    },
    watch: {
        name() {
            this.getSVG();
        },
    },
    async created() {
        this.getSVG();
    },
    methods: {
        async getSVG() {
            try {
                // Fetch the SVG content
                const response = await fetch(this.iconUrl);
                if (!response.ok) throw new Error(`Failed to fetch SVG: ${response.statusText}`);

                // Parse the SVG content to remove width and height
                const rawSvg = await response.text();
                const parser = new DOMParser();
                const svgDoc = parser.parseFromString(rawSvg, 'image/svg+xml');
                const svgElement = svgDoc.querySelector('svg');

                if (svgElement) {
                    svgElement.removeAttribute('width');
                    svgElement.removeAttribute('height');
                    this.svgContent = svgElement.outerHTML; // Save cleaned SVG as a string
                } else {
                    throw new Error('Invalid SVG structure');
                }
            } catch (error) {
                console.error(`Failed to load icon: ${this.name}`, error);
                this.svgContent = null;
            }
        },
    },
};
</script>

<style>
.icon-container {
    display: inline-block;
}

.icon .icon-svg,
.icon-svg {
    display: flex;
    width: 100%;
    height: 100%;

    svg {
        display: inline-block;
        vertical-align: baseline;
        width: 100%;
        height: 100%;
    }
}
</style>
